module.exports = __WEBPACK_EXTERNAL_MODULE_36__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 36
// module chunks = 6 7